import { useQuery } from '@tanstack/react-query';
import { EquipmentReservation } from '@models/warehouse.model';
import { warehouseService } from '@services/warehouse';
import { EQUIPMENT_RESERVATIONS_QUERY_KEY } from './useEquipmentReservations';

export const useEquipmentReservationsForRange = (
  assetId: string | undefined,
  rangeStart: string | Date | undefined,
  rangeEnd: string | Date | undefined,
) => {
  return useQuery<EquipmentReservation[], Error>({
    queryKey: [...EQUIPMENT_RESERVATIONS_QUERY_KEY, 'range', assetId, rangeStart, rangeEnd],
    queryFn: async () => {
      if (!assetId || !rangeStart || !rangeEnd) throw new Error('assetId, rangeStart and rangeEnd are required');
      return warehouseService.getEquipmentReservationsForRange(assetId, rangeStart, rangeEnd);
    },
    enabled: !!assetId && !!rangeStart && !!rangeEnd,
    staleTime: 2 * 60 * 1000,
  });
};

export const useReservationsByTaskForRange = (
  taskId: string | undefined,
  rangeStart: string | Date | undefined,
  rangeEnd: string | Date | undefined,
) => {
  return useQuery<EquipmentReservation[], Error>({
    queryKey: [...EQUIPMENT_RESERVATIONS_QUERY_KEY, 'taskRange', taskId, rangeStart, rangeEnd],
    queryFn: async () => {
      if (!taskId || !rangeStart || !rangeEnd) throw new Error('taskId, rangeStart and rangeEnd are required');
      return warehouseService.getReservationsByTaskForRange(taskId, rangeStart, rangeEnd);
    },
    enabled: !!taskId && !!rangeStart && !!rangeEnd,
    staleTime: 2 * 60 * 1000,
  });
};
